import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ISbStoryData } from '@storyblok/js';
import { StoryblokService } from 'src/app/services/storyblok.service';
import { PageTitlePipe } from '../../pipes/page-title.pipe';
import { StoryblokDirective } from '../../storyblok.directive';
import { BlockStyle, BlockWrapperComponent } from '../block-wrapper/block-wrapper.component';

@Component({
  selector: 'app-blog-post-link-list',
  standalone: true,
  templateUrl: './blog-post-link-list.component.html',
  styleUrls: ['./blog-post-link-list.component.scss'],
  imports: [CommonModule, BlockWrapperComponent, StoryblokDirective, RouterLink, PageTitlePipe],
})
export class BlogPostLinkListComponent implements OnChanges {
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() replacer?: (key: string) => string;
  @Input() style: BlockStyle[];
  @Input() relationshipArrayFields: string;

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('posts') _posts: string[];

  posts: (ISbStoryData & { _editable: string })[];

  private storyblokService = inject(StoryblokService);

  ngOnChanges() {
    const relationships = this.storyblokService.getGlobalData('relationships');
    this.posts = this._posts
      .map(post => {
        return relationships.find(page => page.uuid === post);
      })
      .filter(Boolean);
  }
}
